import React from 'react';
import { InputField } from 'view/pages/Profile/Profile.styles';

interface IProps {
    value: string;
    handlePhoneChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const PhoneInput: React.FunctionComponent<IProps> = ({ value, handlePhoneChange }) => 
{
    return (
        <InputField placeholder='Phone' value={value} onChange={handlePhoneChange} />
    );
};

export default PhoneInput;
